import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getDeleteProjectDocuments } from '../../api/delete-project-documents';

export const getDeleteProjectDocumentsAsync = createAsyncThunk(
  'deleteProjectDocuments/getDeleteProjectDocuments',
  getDeleteProjectDocuments
);

export interface DeleteProjectDocument {
  id: number;
  no: string;
  name: string;
  revisions: string;
  lastStepReview: string;
  reason: string;
  firstName: string;
  lastName: string;
  projectId: number;
  createdAt: Date;
  updatedAt: Date;
}

interface DeleteProjectDocumentState {
  data: DeleteProjectDocument[];
  count: number;
}

const initialState: DeleteProjectDocumentState = {
  data: [],
  count: 0
};

export default createSlice({
  name: 'deleteProjectDocuments',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getDeleteProjectDocumentsAsync.fulfilled,
      (state, action) => {
        state.data = action.payload.data;
        state.count = action.payload.count;
      }
    );
  }
});
